export const formatTelehealthTime = (attachment) => {
    const appointed = attachment.appointed_start;
    const date = new Date(appointed);
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
    const parts = formatter.formatToParts(date);
    const get = (type) => { var _a; return ((_a = parts.find((p) => p.type === type)) === null || _a === void 0 ? void 0 : _a.value) || ''; };
    const dayName = get('weekday');
    const month = get('month');
    const day = get('day');
    const timeStr = `${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
    const nowDay = now.getDay(); // 0-6 (0 = Sunday)
    const targetDay = date.getDay(); // 0-6 (0 = Sunday)
    let prefix = '';
    if (date > now) {
        const diffDays = Math.floor((date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        const isNextWeek = diffDays >= 7 || (targetDay <= nowDay && diffDays >= 1);
        prefix = isNextWeek ? 'next ' : '';
    }
    const time = `${prefix}${dayName}, ${month} ${day}, ${timeStr}`;
    return time;
};
